import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, Box, Text } from '@common-fe/common-fe';

import { OcrProviderOption } from '@/modules/UseMyMoney/UseMyMoney.types';

interface Props {
  provider: OcrProviderOption;
  handleEditProvider: (providerId?: string) => void;
}

const ProviderAddressEmptyState: React.FC<Props> = ({ provider, handleEditProvider }) => {
  const { t } = useTranslation();

  const handleEditSelectedProvider = useCallback(() => {
    handleEditProvider(provider?.id);
  }, [provider?.id, handleEditProvider]);

  return (
    <Box
      data-testId="provider-address_empty-state"
      background="missingContainer"
      pad="spacing16"
      round="container1Round"
    >
      <Text
        data-testId="provider-address_empty-state_title"
        weight={700}
      >
        {t('Action required: Add billing address to submit your claim')}
      </Text>
      <Text
        data-testId="provider-address_empty-state_description"
        margin={{ top: 'spacing2' }}
      >
        {t(`
          Address entered should be the provider's billing address.
          This may differ from their physical location.
          If you are unsure which address to select, in most cases, the providers billing address is a P.O Box.
        `)}
      </Text>

      <Box margin={{ top: 'spacing12' }}>
        <AppButton
          testId="provider-address_empty-state_edit"
          onClick={handleEditSelectedProvider}
        >
          {t('Add Address')}
        </AppButton>
      </Box>
    </Box>
  );
};

export default ProviderAddressEmptyState;
